export default __webpack_public_path__ + "static/media/1791.bdf33ec6.png";